
import * as $ from 'jquery';

import * as CanvasPreview from 'src/integration/canvas/ui/preview';
import * as CanvasUiUtil from 'src/integration/canvas/ui/util';

export function init() {
    syllabusPoller();
}

/**
 * Poll the syllabus for links to course files that can be augmented
 */
function syllabusPoller() {
    // Wrap download links in a span with `ally-file-link-holder link_holder` classes if they aren't already.
    // This allows the user content poller to pick them up and inject the score indicators. This is only necessary
    // when editing a page syllabus. Only adjust the DOM after Canvas has taken a pass on augmenting the syllabus
    // body. This can be determined by checking for the `enhanced` class on the user_content element.
    var $userContent = $('.user_content');
    if (CanvasUiUtil.canManageCourse() && $userContent.hasClass('enhanced')) {
        $('a[href*="/download"]', $userContent).each(function() {
            var $link = $(this);
            CanvasUiUtil.ensureWrappedInLinkHolder($link);
        });
    }

    CanvasPreview.pollPreview(
        function() {
            return true;
        },
        function($previewOverlay) {
            return CanvasUiUtil.getFileId($previewOverlay.find('.ef-file-preview-header-download').attr('href'));
        }
    );
    setTimeout(syllabusPoller, 500);
}
